import React from 'react';
export function Footer() {
  return <footer className="bg-[#110a07] text-brand-cream/40 py-8 px-6 text-center text-sm border-t border-brand-choco" data-id="element-92">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-93">
        <p className="font-serif text-brand-gold/60 font-bold tracking-widest uppercase" data-id="element-94">
          VELAS GOURMET™
        </p>
        
        <p data-id="element-95">
          © {new Date().getFullYear()} Velas Gourmet. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}